import apiService from './apiService';

/**
 * Ecommerce Product Service
 * Fetches products from the public /api/ecommerce endpoint (no auth required)
 */
class ProductService {
    /**
     * Get products with pagination, search, category filter and sorting
     * @param {number}  page      - Page number (default: 1)
     * @param {number}  limit     - Items per page (default: 12)
     * @param {string}  search    - Search query (optional)
     * @param {string}  category  - Category ID filter (optional)
     * @param {string}  sortBy    - Sort key: default | name_asc | price_asc | price_desc | installment_asc | installment_desc (price sorts use MRP)
     * @param {string}  channel   - '' | 'cash' | 'installment' — filter by cash_product / installment_product
     * @param {boolean} featured    - if true, only products with is_featured (home featured section)
     * @returns {Promise<{products: Array, pagination: object}>}
     */
    async getAll(
        page = 1,
        limit = 12,
        search = '',
        category = '',
        sortBy = 'default',
        channel = '',
        featured = false,
        brand = ''
    ) {
        try {
            const params = { page, limit };

            if (search) params.search = search;
            if (category && category !== 'all') params.category = category;
            if (brand && brand !== 'all') params.brand = brand;
            if (sortBy && sortBy !== 'default') params.sortBy = sortBy;
            if (channel === 'cash' || channel === 'installment') {
                params.channel = channel;
            }
            if (featured) {
                params.featured = 'true';
            }

            const response = await apiService.get('/ecommerce/products', params);
            return {
                products:   response.data.products   || [],
                pagination: response.data.pagination || {},
            };
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get single product by ID
     * @param {string} id - Product ID
     * @returns {Promise<object>} Product data
     */
    async getById(id) {
        try {
            const response = await apiService.get(`/ecommerce/products/${id}`);
            return response.data.product;
        } catch (error) {
            throw error;
        }
    }
}

const productService = new ProductService();
export default productService;
